// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkillList__root--Ma1V {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
}

.SkillList__item--sTfl {
    display: flex;
    flex-direction: column;
}

.SkillList__wrapper--sCaG {
    display: grid;
    grid-template-columns: 32px auto;
    grid-gap: 8px;
    align-items: center;
}

.SkillList__name--T2pH {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: var(--secondary-color);
}

.SkillList__description--_aNq {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--secondary-color);
}

.SkillList__image--zOIR {
    width: 32px;
    height: 32px;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/SkillList/SkillList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B","sourcesContent":[".root {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.item {\n    display: flex;\n    flex-direction: column;\n}\n\n.wrapper {\n    display: grid;\n    grid-template-columns: 32px auto;\n    grid-gap: 8px;\n    align-items: center;\n}\n\n.name {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px;\n    color: var(--secondary-color);\n}\n\n.description {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    color: var(--secondary-color);\n}\n\n.image {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n    object-position: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SkillList__root--Ma1V`,
	"item": `SkillList__item--sTfl`,
	"wrapper": `SkillList__wrapper--sCaG`,
	"name": `SkillList__name--T2pH`,
	"description": `SkillList__description--_aNq`,
	"image": `SkillList__image--zOIR`
};
export default ___CSS_LOADER_EXPORT___;
